import type { Schema } from "@/shared/components/Form/types";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";
import { audienceFilterField } from "@/admin/entities/assistant";

export const filterSchema: Schema = {
  audience: audienceFilterField,
  month: {
    label: "Месяц",
    type: "text",
    placeholder: "YYYY-MM",
    xs: 12,
    md: 6,
    fullWidth: true,
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
};
